import React, {Suspense, lazy } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import { Spinner } from 'react-bootstrap';
import ReactDOM from "react-dom/client";
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import './App.css'
import ErrorPage from "./ErrorPage";
import MeusPedidos from './MeusPedidos'
import App from './App'
import Contato from './Contato'
import FormPedidos from './FormPedidos'
const MyLazy = lazy(() => import('./routes/root'));
const router = createHashRouter([
  {
    path: "/",
    element: <MyLazy />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <App />,
      },
      {
        path: "meuspedidos",
        element: <MeusPedidos />,
      },
      {
        path: "contato",
        element: <Contato />,
      },
      {
        path: "pedir",
        element: <FormPedidos />,
      },
    ],
  },
]);
//    if ('serviceWorker' in navigator) {
//  window.addEventListener('load', () => {
//    navigator.serviceWorker.register('/service-worker.js').then(registration => {
//      // console.log('SW registered: ', registration);
//    }).catch(registrationError => {
//      // console.log('SW registration failed: ', registrationError);
//    });
//  });
// }
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Suspense fallback={<Spinner animation="grow" role="status" />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);
